module.exports = __webpack_public_path__ + "img/SC1-simple-tools.720a4e7d.svg";